<template>
  <v-popover class="saveReplyBubble" container="#newReviewList" @show="fetchSavedReplies"
             @hide="resetSavedRepliesPopup" :disabled="savedReplies.popoverDisable" :offset="offset"
             :placement="placement" v-if="isProSubscription">
    <a href="#" data-track="Saved replies - Open popup" @click.prevent><img src="/static/img/reviews/bubble.svg"/></a>

    <popover-new slot="popover" :width="savedRepliesPopupWidth" class="saved-reply-popover">
      <template slot="header">
        Saved replies
      </template>

      <hr/>

      <template v-if="savedReplies.list.length">
        <template v-for="(savedReply, index) in savedReplies.list">
          <div
            class="level margin-bottom-10 pointer"
            @click="useSavedReply(savedReply.content)"
            data-track="Saved replies - Select"
            :class="{'is-flex':isMobile}">
            <div>
              <strong>{{ savedReply.title }}</strong>
              <div>{{ savedReply.content }}</div>
            </div>
            <div class="level-right saved-reply-popover-remove"
                 @click="deleteSavedReply(index)" data-track="Saved replies - Remove">
              <img src="/static/img/reviews/grey_x.svg"/>
            </div>
          </div>
          <hr/>
        </template>
      </template>
      <template v-else>
        <i>No saved replies</i>
        <hr/>
      </template>

      <template v-if="savedReplies.form.show">
        <div class="padding-10 padding-bottom-0 pad-right-15">
          <strong class="margin-bottom-15">Create new saved reply</strong>
          <div class="margin-bottom-10">
            <input class="v-input input margin-top-15" type="text"
                   v-model="savedReplies.form.data.title"
                   placeholder="Title of saved reply">
            <span class="help is-danger has-text-weight-normal"
                  v-if="savedReplies.form.errors.title">{{
                savedReplies.form.errors.title[0]
              }}</span>
          </div>
          <div class="margin-bottom-10">
            <textarea class="v-textarea textarea" placeholder="Write your saved reply here" v-model="savedReplies.form.data.content"></textarea>
            <span class="help is-danger has-text-weight-normal"
                  v-if="savedReplies.form.errors.content">{{
                savedReplies.form.errors.content[0]
              }}</span>
          </div>
          <div class="has-text-right">
            <a href="#" class="blue-link text-underline-no margin-right-17"
               @click.prevent="toggleSavedReplyForm" data-track="Saved replies - Cancel create new">Cancel</a>
            <a href="#" class="blue-link text-underline-no" @click.prevent="createSavedReply" data-track="Saved replies - Create new">Save</a>
          </div>
        </div>
        <hr class="margin-bottom-30"/>
      </template>
      <div class="pad-top-4 margin-bottom-5" v-else>
        <a href="#" class="blue-link text-underline-no" @click.prevent="toggleSavedReplyForm" data-track="Saved replies - Open create form">+
          Add new saved reply</a>
      </div>
    </popover-new>
  </v-popover>
</template>

<script>
/* global flash, dataLayer */
/* eslint no-undef: "error" */
import PopoverNew from './PopoverNew'
import {misc} from '@/mixins'
import axios from 'axios'

export default {
  name: 'SavedRepliesPopup',
  components: {
    PopoverNew
  },
  mixins: [misc],
  props: {
    offset: {
      type: Number,
      default: 0
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      savedReplies: {
        popoverDisable: false,
        list: [],
        form: {
          show: false,
          errors: {},
          data: {
            title: '',
            content: ''
          }
        }
      }
    }
  },
  methods: {
    resetSavedRepliesPopup () {
      this.savedReplies.popoverDisable = false
    },
    useSavedReply (content) {
      this.savedReplies.popoverDisable = true
      this.$emit('selected-saved-reply', content)
    },
    fetchSavedReplies () {
      axios.get(`/${this.businessId}/saved-responses`)
        .then(data => {
          this.savedReplies.list = data.data
        })
    },
    deleteSavedReply (index) {
      const data = this.savedReplies.list[index]
      axios.delete(`/${this.businessId}/saved-responses/${data.id}`)
        .then(() => {
          this.savedReplies.list.splice(index, 1)
        })
    },
    toggleSavedReplyForm () {
      this.savedReplies.form.show = !this.savedReplies.form.show
      if (this.savedReplies.form.show) {
        Object.assign(this.savedReplies.form.data, {title: '', content: ''})
        Object.assign(this.savedReplies.form.errors, {title: '', content: ''})
      }
    },
    createSavedReply () {
      axios.post(`/${this.businessId}/saved-responses`, {
        title: this.savedReplies.form.data.title,
        content: this.savedReplies.form.data.content
      })
        .then((response) => {
          this.savedReplies.list.unshift({
            'id': response.data.id,
            'title': this.savedReplies.form.data.title,
            'content': this.savedReplies.form.data.content
          })
          this.toggleSavedReplyForm()
        })
        .catch(errors => {
          if (errors.response.status === 422) {
            this.savedReplies.form.errors = errors.response.data
          } else {
            flash('There was an error creating the saved reply. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to create the saved reply on Review List',
                'displayedMessage': 'There was an error creating the saved reply. Please try again later!'
              }
            })
          }
        })
    }
  },
  computed: {
    savedRepliesPopupWidth () {
      if (this.isDesktop) {
        return 704
      }

      if (this.isTablet) {
        return 600
      }

      return 288
    }
  }
}
</script>

<style scoped>
.saveReplyBubble {
  position: absolute;
  top: 6px;
  right: 9px;
}

.saved-reply-popover {
  padding-left: 26px !important;
  padding-right: 29px !important;
}

.saved-reply-popover-remove {
  cursor: pointer;
}

.saved-reply-popover hr {
  background-color: rgba(88, 89, 91, 0.32);
  margin: 9px 0 10px;
}

.saved-reply-popover input {
  width: 248px;
  height: 35px;
}

.saved-reply-popover textarea {
  min-height: 63px;
}

/* Mobile */
@media screen and (max-width: 767px) {
  .saved-reply-popover-remove {
    margin-left: auto;
    min-width: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SavedRepliesPopup.vue